import PropTypes from 'prop-types';
import React from 'react';

import SmartLink from '../SmartLink';
import * as styles from './TableOfContents.module.css';

const TableOfContents = ({ title, items = [], currentSection = '', card = false, localLinks = false }) => {
  if (!items) return null;
  const scrollTo = (id) => {
    if (typeof window === 'undefined' || !document) return;
    const el = document.getElementById(id);
    if (el) {
      /*el.scrollIntoView({
        behavior: 'smooth',
      });*/
      let y = el.getBoundingClientRect().top + window.pageYOffset - 84;
      window.scrollTo({ top: y, behavior: 'smooth' });
      // Add id to url for sharing purposes.  Will not cause re-render
      window.history.pushState(null, null, `#${id}`);
    }
  };
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>{title}</div>
      <ul>
        {items.map((item, i) => {
          let anchor = <SmartLink to={item.url}>{item.title}</SmartLink>;
          if (localLinks) {
            anchor = (
              /*eslint-disable-next-line*/
              <a data-id={item.id} onClick={() => scrollTo(item.id)}>
                {item.title}
              </a>
            );
          }
          return (
            <li
              key={i}
              className={[
                styles.item,
                card ? styles.card : styles.list,
                currentSection === item.id ? styles.current : '',
              ].join(' ')}
            >
              {anchor}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

TableOfContents.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
  currentSection: PropTypes.string,
};

export default TableOfContents;
